/**
 * Prepends a Next.js router's basePath to an internal route.
 *
 * next/router and next/link auto-prepend basePath (used for the deploy-PR
 * preview prefix, e.g. `/pr-12345`), but anything that resolves a URL
 * itself — window.open, a raw <a href>, or @latitude/table's getRowHref
 * (a real anchor overlay) — does not, so those call sites need this to keep
 * the prefix on a preview deploy.
 */
export function withBasePath(basePath: string, path: string): string {
  return `${basePath}${path}`;
}
